//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsCarousel } from "@nuskin/design-components";
import NsImage from "./NsImage.vue";

/**
 * NsProductDetailCarousel
 *
 * How to use: Slot in images/videos/whatever
 *
 * @event slide-select  When a slide selection occurs, this event emits a
 * function with params: (index)
 */

export default {
  name: "NsProductDetailCarousel",
  components: { NsCarousel, NsImage },
  props: {
    imageSet: {
      type: Array,
      default() {
        return [];
      }
    },
    // showDots: Boolean,
    slideIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    desktopAndUp() {
      return this.$mq === "desktop" || this.$mq === "desktopHD";
    },
    phabletAndDown() {
      return this.$mq === "mobile" || this.$mq === "phablet";
    }
  },
  methods: {
    /**
     * Gets the width an image should be in phablet or mobile
     * Equals the available width minus spacing for left and right arrows
     * Max-width: 290
     */
    getImageWidth() {
      return Math.min(window.innerWidth - 30 - 90, 290) + "px";
    },
    /**
     * On mobile, this will update the current slide index
     */
    handlePositionChanged(index) {
      if (this.phabletAndDown) {
        this.$emit("slide-select", index);
      }
    }
  }
};
